import { useState, useEffect } from "react";
import Header from "../components/Header";
import DiagramViewer from "../components/DiagramViewer";
import PartsTable from "../components/PartsTable";
import ListingsSection from "../components/ListingsSection";
import ModelSelectorModal from "../components/ModelSelectorModal";
import diagram from "../assets/images/jetski-diagram.png";

import { partsCatalog } from "../data/partsCatalog";



import { diagramMap } from "../data/diagramMap";








const hotspots = [
  { id: 1, x: 53, y: 73 },
  { id: 2, x: 61, y: 68 },
  { id: 3, x: 36, y: 63 }
];


const years = [];

for (let y = 2026; y >= 1996; y--) {
  years.push(y);
}


function PartsDiagramPage({ standalone = true }) {

  const [selectedPart, setSelectedPart] = useState(null);
  const [hoveredPart, setHoveredPart] = useState(null);
const [modelSelectorOpen, setModelSelectorOpen] = useState(false);
const [selectedYear, setSelectedYear] = useState(null);
const [selectedMake, setSelectedMake] = useState(null);
const [selectedModel, setSelectedModel] = useState(null);
const [selectedSystem, setSelectedSystem] = useState(null);
const [selectedSubSystem, setSelectedSubSystem] = useState(null);

const systemData = partsCatalog[selectedSystem];

const selectedSki =
  selectedYear && selectedMake && selectedModel
    ? `${selectedYear} ${selectedMake} ${selectedModel}`
    : null;



const parts = Array.isArray(systemData)
  ? systemData
  : selectedSubSystem
  ? systemData?.[selectedSubSystem] || []
  : [];

useEffect(() => {
  setSelectedPart(null);
}, [selectedSystem, selectedSubSystem]);

const makes = ["Yamaha", "SeaDoo"];

const models = {
  Yamaha: [
    "VX Cruiser HO", // ✅ FIXED
    "FX HO",
    "FX SVHO",
    "GP1800R",
    "VXR",
    "EX SPORT",
    "EX DELUXE",
    "VX SPORT 110"
  ],

  SeaDoo: [
    "GTX 300",
    "RXP X 300",
    "RXP 260",
    "RXT 300",
    "SPARK TRIXX",
    "SPARK 2UP"
  ]
};
const selectedSkiLabel =
  selectedYear && selectedMake && selectedModel
    ? `${selectedYear} ${selectedMake} ${selectedModel}`
    : "Update Year / Make / Model";


  return (
   <div style={styles.page}>
      {/* Hide header when in preview */}
    {standalone && <Header />}

   <div
  style={{
    ...styles.wrapper,
    margin: standalone ? "32px auto" : "80px auto"
  }}
>

     {standalone && (
  <div style={styles.titleRow}>
    ← Back to Home
  </div>
)}

      <div style={styles.layout}>




  <DiagramViewer
diagram={
  selectedSki && selectedSystem
    ? (
        // ✅ Case 1: subsystem exists (Engine → Intake)
        selectedSubSystem &&
        diagramMap[selectedSki]?.[selectedSystem]?.[selectedSubSystem]
      ) ||
        // ✅ Case 2: system itself has a direct diagram (Intake as system)
        diagramMap[selectedSki]?.[selectedSystem] ||
        diagram
    : diagram
}

 system={selectedSystem}
 hotspots={hotspots}
 selectedPart={selectedPart}
 hoveredPart={hoveredPart}
 setSelectedPart={setSelectedPart}
 setHoveredPart={setHoveredPart}
/>
<PartsTable
  parts={parts}
  selectedPart={selectedPart}
  hoveredPart={hoveredPart}
  setSelectedPart={setSelectedPart}
  setHoveredPart={setHoveredPart}
  openSelector={() => setModelSelectorOpen(true)}
  selectedSkiLabel={selectedSkiLabel}
/>
</div>

      </div>

           {selectedPart && (
        <ListingsSection
          selectedPart={selectedPart}
          parts={parts}
        />
      )}

<ModelSelectorModal
  modelSelectorOpen={modelSelectorOpen}
  setModelSelectorOpen={setModelSelectorOpen}
  selectedYear={selectedYear}
  setSelectedYear={setSelectedYear}
  selectedMake={selectedMake}
  setSelectedMake={setSelectedMake}
  selectedModel={selectedModel}
  setSelectedModel={setSelectedModel}
  selectedSystem={selectedSystem}
  setSelectedSystem={setSelectedSystem}
selectedSubSystem={selectedSubSystem}
  setSelectedSubSystem={setSelectedSubSystem}
  makes={makes}
  models={models}
  years={years}
/>



    </div>
  );
}

export default PartsDiagramPage;

const styles = {

page:{
minHeight:"100vh",
background:"linear-gradient(180deg,#F4F7FF 0%,#EEF2FF 100%)"
},








wrapper:{
  maxWidth:1400,
  margin:"32px auto",
  padding:"0 48px"
},


modalOverlay:{
position:"fixed",
top:0,
left:0,
right:0,
bottom:0,
background:"rgba(0,0,0,0.35)",
display:"flex",
alignItems:"center",
justifyContent:"center",
zIndex:1000
},

modal:{
position:"relative",

width:520,
background:"#fff",
borderRadius:20,
padding:32,

boxShadow:"0 30px 80px rgba(0,0,0,0.25)"
},

modalTitle:{
fontSize:20,
fontWeight:600,
marginBottom:20
},

selectorRow:{
display:"flex",
gap:12,
marginBottom:20
},

select:{
flex:1,
padding:"10px 12px",
borderRadius:10,
border:"1px solid rgba(0,0,0,0.1)"
},

loadButton:{
padding:"12px 18px",
borderRadius:14,
border:"none",
background:"#2563eb",
color:"#fff",
fontWeight:600,
cursor:"pointer"
},


titleRow:{
display:"flex",
alignItems:"center",
gap:10,
fontSize:20,
fontWeight:600,
marginBottom:24
},

layout:{
display:"grid",
gridTemplateColumns:"1fr 420px",
gap:40,
alignItems:"start"
},

};